import { render, staticRenderFns } from "./realEstate.vue?vue&type=template&id=2fd3d0de&scoped=true&"
import script from "./realEstate.vue?vue&type=script&lang=js&"
export * from "./realEstate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3d0de",
  null
  
)

export default component.exports